// ReviewsTextOnly.jsx
import React from "react";
import { motion } from "framer-motion";
import { FaStar, FaQuoteLeft } from "react-icons/fa";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

const item = {
  hidden: { opacity: 0, x: -30, scale: 0.98 },
  show: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { type: "spring", stiffness: 80, damping: 14 },
  },
};

export default function ReviewsTextOnly() {
  const reviews = [
    {
      name: "Aarav N.",
      role: "Parent, Grade 9",
      rating: 5,
      text:
        "Rankridge balances academics and character. My son’s confidence and problem-solving have grown significantly.",
    },
    {
      name: "Suhana R.",
      role: "Alumna, IIT Freshman",
      rating: 5,
      text:
        "IIT-JEE foundation is practical and structured. Consistent mocks and mentorship made all the difference.",
    },
    {
      name: "Rohan K.",
      role: "Student, Grade 10",
      rating: 5,
      text:
        "Smart classes, helpful doubt sessions, and a friendly vibe. I actually enjoy coming to school!",
    }
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-emerald-50 via-white to-emerald-50 py-16">
      {/* soft background accents */}
      <div className="pointer-events-none absolute -top-24 -right-24 h-80 w-80 rounded-full bg-emerald-200/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-green-300/20 blur-3xl" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-gray-900">
            What Parents & Students Say
          </h2>
          <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
            Real stories from our community—on learning, growth, and success.
          </p>
          <div className="mt-6 mx-auto h-1 w-28 rounded-full bg-emerald-600" />
        </motion.div>

        {/* Reviews Grid */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {reviews.map((r) => (
            <motion.article
              key={r.name + r.role}
              variants={item}
              whileHover={{ y: -4, transition: { type: "spring", stiffness: 200, damping: 16 } }}
              className="group relative overflow-hidden rounded-2xl border border-emerald-100 bg-white p-6 shadow-sm ring-1 ring-black/5 hover:shadow-md transition-shadow"
            >
              {/* quote icon */}
              <div className="mb-3 flex items-center gap-2 text-emerald-700">
                <FaQuoteLeft className="text-xl opacity-80" />
                <div className="flex items-center gap-1" aria-label={`Rating ${r.rating} out of 5`}>
                  {Array.from({ length: r.rating }).map((_, i) => (
                    <FaStar key={i} className="text-yellow-500" />
                  ))}
                </div>
              </div>

              {/* review text */}
              <p className="text-gray-800 leading-relaxed">
                “{r.text}”
              </p>

              {/* author */}
              <div className="mt-5">
                <p className="font-semibold text-gray-900">{r.name}</p>
                <p className="text-xs text-gray-500">{r.role}</p>
              </div>

              {/* subtle highlight on hover */}
              <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                   style={{ background: "radial-gradient(600px circle at var(--x,50%) var(--y,50%), rgba(16,185,129,0.08), transparent 40%)" }} />
            </motion.article>
          ))}
        </motion.div>

        {/* CTA */}
        {/* <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-12 flex items-center justify-center"
        >
         <a
            href="#admissions"
            className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-5 py-3 text-white shadow-lg hover:bg-emerald-700 focus:outline-none focus:ring-4 focus:ring-emerald-300"
          >
            Join Our Community
          </a> 
        </motion.div> */}
      </div>
    </section>
  );
}
